import { InfoCircleFilled } from '@ant-design/icons';
import { Colors, Flex, Button, Text } from '@revenuemarket/cds';
import { ResponseStatus } from '@revenuemarket/http';
import { overlays } from '@revenuemarket/overlays';
import { Toast } from '@revenuemarket/ui';
import { Alert } from 'antd';
import { useRouter } from 'next/router';

import { useAcceptMandateRequest, useRejectMandateRequest } from '~hooks/queries/setting/query';

import useGetAlertBannerInfo from './useGetAlertBannerInfo';
import CommonModal from '../Modal/CommonModal';

const InfoAlertBanner = () => {
  const router = useRouter();
  const isNotTargetPage = router.pathname.includes('settings');
  const { organizationsInfo, getAlertInfo, pendingMandateRequest } = useGetAlertBannerInfo();
  const { mutateAsync: acceptMandateRequest } = useAcceptMandateRequest();
  const { mutateAsync: rejectMandateRequest } = useRejectMandateRequest();

  const handleAcceptMandateRequest = async () => {
    const response = await acceptMandateRequest({
      taxClientId: String(pendingMandateRequest?.taxClientId),
    });

    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('세무대리인이 등록됐어요');
    } else {
      Toast.error('세무대리인 등록에 실패했습니다.');
    }
  };

  const handleRejectMandateRequest = () => {
    overlays.open(({ isOpen, onClose }) => (
      <CommonModal
        open={isOpen}
        onCancel={onClose}
        footer={null}
        width={460}
        title="세무대리인의 등록 요청을 정말 거절할까요?"
      >
        <Flex direction="column" gap={8} style={{ paddingTop: 8 }}>
          <Text textStyle="14_600" style={{ color: Colors.gray800 }}>
            {pendingMandateRequest?.taxAgentName}
          </Text>
          <Text textStyle="14_400" style={{ color: Colors.gray800 }}>
            요청을 거절하면 세무대리인은 이 회사 공간에 참여할 수 없어요.
          </Text>
        </Flex>
        <Flex justify="flex-end" gap={8} style={{ paddingTop: 8 }}>
          <Button buttonSize="large" border onClick={onClose}>
            닫기
          </Button>
          <Button
            buttonSize="large"
            buttonType="primary"
            danger
            onClick={async () => {
              const response = await rejectMandateRequest({
                taxClientId: String(pendingMandateRequest?.taxClientId),
              });
              if (response.Status === ResponseStatus.SUCCESS) {
                Toast.success('등록을 거절했어요');
              } else {
                Toast.error('등록 거절에 실패했습니다.');
              }
              onClose();
            }}
          >
            거절하기
          </Button>
        </Flex>
      </CommonModal>
    ));
  };

  const alertInfo = getAlertInfo();

  if (!organizationsInfo) {
    return null;
  }

  return !isNotTargetPage && (alertInfo || pendingMandateRequest) ? (
    <Flex direction="column" gap={8} style={{ flexShrink: 0, margin: '8px 8px 0px 8px' }}>
      {alertInfo && (
        <Alert
          showIcon
          style={{
            alignItems: 'center',
            padding: 8,
            height: 44,
            cursor: 'pointer',
            flex: 1,
          }}
          icon={alertInfo?.icon}
          type={alertInfo.type as 'success' | 'info' | 'warning' | 'error'}
          description={alertInfo.description}
          onClick={alertInfo.onClick}
        />
      )}
      {pendingMandateRequest && (
        <Alert
          showIcon
          style={{
            alignItems: 'center',
            padding: 8,
            height: 44,
            cursor: 'pointer',
            flex: 1,
          }}
          icon={<InfoCircleFilled color="#19B9B1" width={16} height={16} />}
          type="info"
          description={
            <Flex align="center" gap={8}>
              <Text textStyle="14_400">{`${pendingMandateRequest.taxAgentName}에서 수임처 등록을 요청했어요.`}</Text>
              <Button buttonSize="small" buttonType="primary" onClick={handleAcceptMandateRequest}>
                요청 수락하기
              </Button>
              <Button
                buttonSize="small"
                style={{ backgroundColor: Colors.grayOpacity04 }}
                onClick={handleRejectMandateRequest}
              >
                요청 거절하기
              </Button>
            </Flex>
          }
        />
      )}
    </Flex>
  ) : null;
};

export default InfoAlertBanner;
